// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__2ce6T","fullWidth":"Container_fullWidth__3yNe7"};